import myNetwork from '@/mycore/network/apimanagement';

/**
 * API lay thong tin fptplay
 *
 * @param {*} myData
 * @param {*} callback
 */


export function getLocation(callback) {

    myNetwork.post('/api/saleplatform/geography/get-location')
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

export function getDistrict(callback, locationid) {

    myNetwork.post('/api/saleplatform/geography/get-district', {
            'LocationId': locationid
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

export function getWard(callback, locationid, districtid) {
    myNetwork.post('/api/saleplatform/geography/get-ward', {
            'LocationId': locationid,
            'DistrictId': districtid
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

export function getStreet(callback, locationid, districtid, wardid) {

    myNetwork.post('/api/saleplatform/geography/get-street', {
            'LocationId': locationid,
            'DistrictId': districtid,
            'WardId': wardid,
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

// Lấy thông tin gói FPTPlay
export function getCategories(displayType, locationId, districtId, wardId, source = 1, callback) {
    myNetwork.post('/api/saleplatform/catalog/get-categories', {
            'CusTypeId': 102,
            'CusTypeL2Id': 132,
            'PageType': displayType,
            'LocationId': locationId,
            'DistrictId': districtId,
            'WardId': wardId,
            'source': source
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

// Tạo đơn hàng
export function createFptPlayOrder(callback, data) {

    myNetwork.post('/api/saleplatform/order/fptplay/create-order', {...data })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

export function createFptPlaySAOrder(callback, data) {

    myNetwork.post('/api/saleplatform/order/fptplay/create-order-sa', {...data })
        .then(response => {

            callback(true, response.data, null);
        })
        .catch(error => {

            callback(false, null, { message: error });
        });
}

// Tạo đơn hàng
export function getCategoryDetail(callback, locationid, districtid, wardid, buildingid,combo, CategoryService, orderid) {
    myNetwork.post('/api/saleplatform/catalog/get-category-detail', {
            "LocationId": locationid,
            "DistrictId": districtid,
            "WardId": wardid,
            "CusTypeId": 102,
            "CusTypeL2Id": 132,
            "ComboType": combo,
            "CategoryServices": CategoryService,
            "OrderId": orderid,
            "BuildingId": buildingid,
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
export function getPrePaidPoliciesDetail(callback, locationid, districtid, wardid, combo, CategoryService) {
    myNetwork.post('/api/saleplatform/catalog/get-category-detail-none-id', {
            "LocationId": locationid,
            "DistrictId": districtid,
            "WardId": wardid,
            "CusTypeId": 102,
            "CusTypeL2Id": 132,
            "ComboType": combo,
            "CategoryServices": CategoryService,
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
// Cập nhật thông tin đơn Hàng

export function updateOrderDetail(callback, data) {
    myNetwork.post('/api/saleplatform/order/update-order-detail', {...data })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
// Đổi gói dịch vụ

export function changeServices(callback, comboType, CategoryService, pageType, locationId, districtId, wardId, source = 1, sysName) {

    myNetwork.post('/api/saleplatform/catalog/change-package', {
            "ComboType": comboType,
            "CategoryServices": CategoryService,
            "PageType": pageType,
            'CusTypeId': 102,
            'CusTypeL2Id': 132,
            'LocationId': locationId,
            'DistrictId': districtId,
            'WardId': wardId,
            'source': source,
            'SysName': sysName
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

export function getOrderDetailDisplay(callback, orderid) {
    myNetwork.post('api/saleplatform/order/get-detail-display', {
            "OrderId": orderid,
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
//Thanh toán qua ví điện tử
export function getPaymentApi(url, callback, orderid) {

    myNetwork.post(url, {
            "OrderId": orderid
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
export function getPaymentHome(url, callback, orderid, ordercode) {

    myNetwork.post(url, {
            "OrderId": orderid,
            "OrderCode": ordercode
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
// Áp dụng voucher
export function applyVoucher(callback, data) {
    myNetwork.post('/api/saleplatform/voucher/apply-voucher', {...data })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
// Lấy thông tin thanh toán
export function getInfoPayment(callback, orderid, paidtype, totalVAT, voucher) {
    myNetwork.post('/api/saleplatform/payment/get-info-payment', {
            "OrderId": orderid,
            "PaidType": paidtype,
            "TotalVAT": totalVAT,
            "Vouchers" : voucher
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
//Lấy phương thức thanh toán
export function getPaymentMethod(callback, orderid) {

    myNetwork.post('/api/saleplatform/payment/get-payment-method/v2', {
            "OrderId": orderid
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}


// Kiểm tra trạng thái thanh toán đơn hàng
export function checkPayment(callback, orderid) {

    myNetwork.post('/api/saleplatform/payment/check-payment', {
            "OrderId": orderid
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}


// Tìm kiếm thông tin đơn hàng


export function searchOrder(callback, ordercode) {

    myNetwork.post('/api/saleplatform/order/search-order', {
            "OrderCode": ordercode
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

//
export function getCategoriesRelated(callback, orderid) {

    myNetwork.post('/api/saleplatform/catalog/get-category-related', {
            "OrderId": orderid
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

// Lấy thông tin đơn hàng

export function getOrderDetail(callback, orderid, isShortLink) {
    myNetwork.post('/api/saleplatform/order/get-order-detail', {
            "OrderId": orderid,
            "isShortLink": isShortLink,
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
// get timezone
export function getTimeZone(callback,saleId, date, orderid) {
    myNetwork.post('/api/saleplatform/appointment/get-timezone', {
            "OrderId": orderid,
            "SaleTeamId":saleId,
            "AppointmentDate": date
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
// Cập nhật thời gian lắp đặt
export function updateTimeOrder(callback, orderid, date, time) {
    myNetwork.post('/api/saleplatform/appointment/update-appointment', {
            "OrderId": orderid,
            "Date": date,
            "Timezone": time
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

//08032022: thuantv11 -add : get foxpay description
export function getFoxpayDescription(callback) {

    myNetwork.post('/api/cms/sale-foxpay')
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}

// tracking order

export function trackingOrder(callback, ordercode) {
    myNetwork.post('/api/saleplatform/order/tracking-order', {
            "OrderCode": ordercode
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}


//
export function getServiceFromName(callback, routerName) {
    myNetwork.post('/api/saleplatform/catalog/get-service-info', {
            "RouteName": routerName
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, { message: error });
        });
}
export function changePaymentMethod(callback, paidtype, orderid, billType) {
    myNetwork.post('/api/saleplatform/voucher/change-payment-method', {
            "OrderId": orderid,
            "PaymentType": paidtype,
            "BillType": billType || 5
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, {
                message: error
            });
        });
}
export function getBuilding(callback, saleTeamId, locationid, districtid, wardid) {

    myNetwork.post('/api/saleplatform/geography/get-building', {
            'SaleTeamId': saleTeamId,
            'LocationId': locationid,
            'DistrictId': districtid,
            'WardId': wardid,
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, {
                message: error
            });
        });
}
//
export function CreatePayment(callback, OrderId, PaidType) {
    myNetwork
        .post('/api/saleplatform/payment/create-payment-process', { OrderId: OrderId, PaidType: PaidType })
        .then((response) => {
            callback(true, response.data, null);
        })
        .catch((error) => {
            callback(false, null, { message: error });
        });
}
/* config payment */
export function getConfigPayment(callback, PaidType) {
    myNetwork.post('/api/saleplatform/configuration/config-payment', {
            'PaidType': PaidType
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, {
                message: error
            });
        });
}
/* status order */
export function getStatusOrder(callback, OrderId) {
    myNetwork.post('/api/saleplatform/order/get-status', {
            'OrderId': OrderId
        })
        .then(response => {
            callback(true, response.data, null);
        })
        .catch(error => {
            callback(false, null, {
                message: error
            });
        });
}
